var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"h-container"},[_c('Commonheader2'),_c('div',{staticClass:"h-wrap"},[_c('div',{staticClass:"h-main"},[_c('router-view',{staticStyle:{"margin-top":"-0.48rem"}}),_c('Commonfooter')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }